@if (viewBox(); as box) {
  @if (hasContent()) {
    <svg class="inspection-overlay-svg" [attr.viewBox]="box" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
      @if (overlay()?.bucketCircle; as circle) {
        <circle class="bucket-circle" [attr.cx]="circle.centerX" [attr.cy]="circle.centerY" [attr.r]="circle.radius"
          fill="none" stroke="#ffd400" stroke-width="2" vector-effect="non-scaling-stroke" />
      }
      @if (overlay()?.stainCircle; as circle) {
        <circle class="stain-circle" [attr.cx]="circle.centerX" [attr.cy]="circle.centerY" [attr.r]="circle.radius"
          fill="none" stroke="#00c853" stroke-width="2" vector-effect="non-scaling-stroke" />
      }
      @for (stainBox of overlay()?.stainBoxes ?? []; track $index) {
        <rect class="stain-box" [attr.x]="stainBox.x" [attr.y]="stainBox.y" [attr.width]="stainBox.width"
          [attr.height]="stainBox.height" fill="none" stroke="red" stroke-width="2"
          vector-effect="non-scaling-stroke" />
      }
    </svg>
  }
}
